exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product.collection-product[data-v-bac342d2]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:5px 8px}.image-box[data-v-bac342d2]{background:#FFFFFF}\n", ""]);

// exports
